<template>
	<div class="bright container-fluid py-2">
		<router-view @childrenRoute="hideNonChildren" />
		<div class="row" v-if="!isChildRoute">
			<div class="col-md-12">
				<div class="row">
					<div class="col-md-12 mb-0 pl-0">
						<ListItem class="mb-0" title="TOP 10 PIUTANG" :data="reportdatapiutang.data" itemcol="Name" valuecol="SumAmountInDC" 
							textvaluecol="SAM"
							url="/finance/report-group?tab=1"/>
					</div>
				</div>

				<div class="row" v-if="false">
					<div class="col-md-12 mb-0 pl-0">
						<ListItemPiutangByAging class="mb-0" title="TOP 10 PIUTANG BY AGING" :data="reportdatapiutangbyaging.data" itemcol="Name" valuecol="SumAmountInDC" 
							textvaluecol="SAM"
							url="/finance/report-group?tab=1"/>
					</div>
				</div>

				<div class="row">
					<div class="col-md-12 mb-0 pl-0">
						<ListItem3 class="mb-0" title="TOP 10 HUTANG" :data="reportdatautang.data" itemcol="VendorName" valuecol="SumAmountInDC" 
							textvaluecol="FungsiName"
							url="/finance/report-group?tab=10"/>
					</div>
				</div>

				<div class="row" v-if="false">
					<div class="col-md-12 mb-0 pl-0">
						<ListItemHutangByAging class="mb-0" title="TOP 10 HUTANG BY AGING" :data="reportdatautangbyaging.data" itemcol="Name" valuecol="SumAmountInDC" 
							textvaluecol="FungsiName"
							url="/finance/report-group?tab=10"/>
					</div>
				</div>

			</div>
		</div>
		<Footer/>
	</div>
</template>

<script>
import BarCard from '@/views/pages/BarCard.vue'
import ListItem from '@/views/pages/ListItem2.vue'
import ListItem3 from '@/views/pages/ListItem3.vue'
import ListItemPiutangByAging from '@/views/pages/ListItemPiutangByAging.vue'
import ListItemHutangByAging from '@/views/pages/ListItemHutangByAging.vue'
import ListCompare from '@/views/pages/ListCompare.vue'
import Customer from '@/components/page/Customer.js'
import Footer from '@/views/Footer.vue'
import { Rainbow, FuelColor, Config, Penanggalan, AxiosWithJar } from '@/utility.js'

export default{
	extends: Customer,
	components:{
		Footer,
		ListItem,
		ListItem3,    
		ListItemPiutangByAging,
		ListItemHutangByAging,
	},
    mounted() {
		//this.$emit('childrenRoute');
		this.hideNonChildren();
		//this.loadTop();
		//this.$store.state.page=window.location.pathname.split('/')[1]===''?'overview':window.location.pathname.split('/')[1];
		//document.title=this.$store.state.page+' - Dashboard'
		this.getDataTopPiutang()
		this.getDataTopPiutangByAging()
		this.getDataTopHutang()
		this.getDataTopHutangByAging()
    },
	data() {
		return {
			isChildRoute: false,
			spbu:{ 
				data:{}, list:[], types:[] 
			},
			loading: {
				table: false,
			},
			reportdatapiutang: {
				data: [],
			},
			reportdatautang: {
				data: [],
			},
			reportdatapiutangbyaging: {
				data: [],
			},
			reportdatautangbyaging: {
				data:[],
			},
		}
	},
	watch: {
		$route(to, from) {
            this.hideNonChildren();
        }
	},
    methods:{
		hideNonChildren() {
            this.isChildRoute = this.$route.path !== '/finance';
        },
		
		getDataTopPiutang() {
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/customer/top-piutang?'
            
            //this.urlRequestParams+='year='+this.year
            //this.urlRequestParams+='&month='+this.month

			this.loading.table = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                this.reportdatapiutang = response.data;
                //console.log('data: ' + JSON.stringify(this.reportData))
            })
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.table = false;
			})     

        },

		getDataTopPiutangByAging() {
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/customer/top-piutang-by-aging?'
            
            //this.urlRequestParams+='year='+this.year
            //this.urlRequestParams+='&month='+this.month

			this.loading.table = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                this.reportdatapiutangbyaging = response.data;
                //console.log('data: ' + JSON.stringify(this.reportData))
            })
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.table = false;
			})     

        },

		getDataTopHutang() {
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/vendor/top-utang?'
            
            //this.urlRequestParams+='year='+this.year
            //this.urlRequestParams+='&month='+this.month

			this.loading.table = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                this.reportdatautang = response.data;
                //console.log('data: ' + JSON.stringify(this.reportData))
            })
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.table = false;
			})     

        },

		getDataTopHutangByAging() {
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/vendor/top-utang-by-aging?'
            
            //this.urlRequestParams+='year='+this.year
            //this.urlRequestParams+='&month='+this.month

			this.loading.table = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                this.reportdatautangbyaging = response.data;
                //console.log('data: ' + JSON.stringify(this.reportData))
            })
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.table = false;
			})     

        },

	},
}

</script>